import React from 'react';
import { Switch } from 'react-router-dom';
import AppliedRoute from './components/AppliedRoute';
import AuthenticatedRoute from './components/AuthenticatedRoute';
import UnauthenticatedRoute from './components/UnauthenticatedRoute';

import Home from './containers/Order';
import Login from './containers/Login';
// import NotFound from './containers/NotFound';
import Admin from './containers/Admin';
import OrdersManager from './containers/OrdersManager';
import ProductsManager from './containers/ProductsManager';
// import Reports from './containers/Reports';
export default function Routes({ appProps }) {
    return (
        <Switch>
            <AppliedRoute path="/" exact component={Home} appProps={appProps} />
            <AppliedRoute path="/index.html" exact component={Home} appProps={appProps} />
            <UnauthenticatedRoute path="/login" exact component={Login} appProps={appProps} />
            <AuthenticatedRoute path="/admin" exact component={Admin} appProps={appProps} />
            <AuthenticatedRoute path="/order-management" exact component={OrdersManager} appProps={appProps} />
            <AuthenticatedRoute path="/product-management" exact component={ProductsManager} appProps={appProps} />
            {/* <AuthenticatedRoute path="/reports" exact component={Reports} appProps={appProps} /> */}
            {/* <AuthenticatedRoute path="/manage-orders" exact component={ManagePlatforms} appProps={appProps} /> */}
            {/* <Route component={Home} /> */}
            {/* <Route component={NotFound} /> */}
            <AppliedRoute component={Home} appProps={appProps} />
        </Switch>
    );
}
